import Resource from './Resource';

export default class Discipline extends Resource {
	constructor(options={}) {
		let {
			route = 'discipline',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
